/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_MajorInputs */



/**
* | output |
* | --- |
* | "Major" |
*
* @param {Sanction_Sub_MajorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_major = /** @type {((inputs?: Sanction_Sub_MajorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_MajorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Majeure")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mayor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Maior")
	if (locale === "it") return /** @type {LocalizedString} */ ("Maggiore")
	return /** @type {LocalizedString} */ ("Major")
});